import {
  POWER_BANK_RENT_LOADING,
  POWER_BANK_RENT_ERROR,
  POWER_BANK_RENT_LIST,
  POWER_BANK_RENT_FILTERS
} from "actions/chargers/rent/constants";

const initialState = {
  loading: false,
  errors: [],

  filters: [],
  list: {
    content: []
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case POWER_BANK_RENT_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case POWER_BANK_RENT_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case POWER_BANK_RENT_FILTERS:
      return {
        ...state,
        errors: [],
        filters: action.payload.content,
      };
    case POWER_BANK_RENT_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/chargers/powerBankRentReducer.js